import React from 'react';
import { Check, ArrowRight, Star, ShieldCheck, Clock, Zap } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-206">
      <div className="max-w-4xl mx-auto" data-id="element-207">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200 relative" data-id="element-208">
          {/* Top Banner */}
          <div className="bg-[#18181B] text-white p-8 md:p-12 text-center relative overflow-hidden" data-id="element-209">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/20 via-transparent to-emerald-900/20 pointer-events-none" data-id="element-210"></div>
            <div className="relative z-10" data-id="element-211">
              <div className="inline-flex items-center gap-2 bg-rose-500/20 border border-rose-500/30 text-rose-300 font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider text-xs" data-id="element-212">
                <Clock className="w-3.5 h-3.5" data-id="element-213" />
                Oferta por tiempo limitado
              </div>
              <h2 className="text-2xl md:text-5xl font-black tracking-tight" data-id="element-214">
                📦 Todo lo que recibís hoy
              </h2>
            </div>
          </div>

          <div className="p-6 md:p-14" data-id="element-215">
            {/* Benefits grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-216">
              {[{
              text: 'Manual de Biohacking + 800 Recetas para la Pre y Postmenopausia',
              bold: true
            }, {
              text: 'Todos los 6 bonos incluidos gratis'
            }, {
              text: 'Acceso inmediato tras la compra'
            }, {
              text: 'Descarga digital en cualquier dispositivo'
            }, {
              text: 'Un solo pago — sin suscripción'
            }, {
              text: 'Actualizaciones futuras incluidas'
            }].map((item, i) => <div key={i} className="flex items-start gap-3 p-3 rounded-xl border border-gray-50" data-id="element-217">
                  <div className="bg-emerald-100 p-1 rounded-full mt-0.5 shrink-0" data-id="element-218">
                    <Check className="w-4 h-4 text-emerald-600" strokeWidth={3} data-id="element-219" />
                  </div>
                  <span className={`text-base ${item.bold ? 'font-bold text-gray-900' : 'text-gray-700'}`} data-id="element-220">
                    {item.text}
                  </span>
                </div>)}
            </div>

            {/* Price box */}
            <div className="bg-amber-50 rounded-2xl p-6 md:p-10 text-center border border-amber-100 mb-8 relative overflow-hidden" data-id="element-221">
              <div className="absolute -right-16 -top-16 w-48 h-48 bg-amber-100 rounded-full blur-[50px] opacity-50 pointer-events-none" data-id="element-222"></div>

              <div className="relative z-10" data-id="element-223">
                <div className="inline-flex items-center gap-2 bg-white text-amber-700 px-4 py-1.5 rounded-full text-xs font-bold mb-4 border border-amber-200 shadow-sm" data-id="element-224">
                  <Zap className="w-3.5 h-3.5" data-id="element-225" />
                  OFERTA LIMITADA — APROVECHÁ AHORA
                </div>
                <p className="text-gray-400 text-base line-through mb-1" data-id="element-226">
                  Precio regular: USD $49
                </p>
                <span className="text-5xl md:text-7xl font-black text-gray-900 tracking-tighter block mb-2" data-id="element-227">
                  USD $12,99
                </span>
                <p className="text-gray-500 text-sm" data-id="element-228">
                  (Pagás en tu moneda local)
                </p>
              </div>
            </div>

            {/* CTA */}
            <a href="https://checkot2.descargatop.com/cart/50167803609445:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white text-center text-xl md:text-2xl font-bold py-5 rounded-2xl shadow-lg hover:shadow-emerald-500/30 transition-all transform hover:-translate-y-0.5 group relative overflow-hidden" data-id="element-229">
              <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-230">
                OBTENER MI ACCESO AHORA
                <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-231" />
              </span>
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-232"></div>
            </a>

            {/* Trust */}
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 mt-6 text-gray-500 text-sm font-medium" data-id="element-233">
              <div className="flex items-center gap-2" data-id="element-234">
                <div className="flex" data-id="element-235">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-amber-400 fill-current" data-id="element-236" />)}
                </div>
                <span data-id="element-237">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-238">
                <ShieldCheck className="w-4 h-4 text-emerald-600" data-id="element-239" />
                <span data-id="element-240">Acceso de por vida</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}